import { createContext } from "react";

export interface AlertContextType {
  show: boolean;
  alertText: string;
  error: boolean;
  handleShow: (text: string, isError: boolean) => void;
  handleHide: () => void;
}

const AlertContext = createContext<AlertContextType>({
  show: false,
  alertText: "",
  error: false,
  handleShow: () => {},
  handleHide: () => {},
});

export default AlertContext;
